<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditInfo"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="updateEducationHistory"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Education History</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <h1 class="font-extrabold ml-1">Institution Details</h1>
          <div class="p-4 grid grid-cols-2 gap-4">
            <div class="text-sm col-span-1">
              <div>
                <label class="block pb-1">Institution Name</label>
                <input
                  v-model="info.InstitutionName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div>
                <label class="block pb-1">Course Name</label>
                <input
                  v-model="info.CourseName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div>
                <label class="block pb-1">Start Date</label>
                <input
                  type="date"
                  v-model="info.StartDate"
                  required
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div>
                <label class="block pb-1">End Date</label>
                <input
                  type="date"
                  v-model="info.EndDate"
                  required
                  :min="info.StartDate"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div>
                <label class="block pb-1">Awarded</label>
                <input
                  v-model="info.Awarded"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-md px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import decryptData from "@/utils/decrypt";

export default {
  name: "EditEducationHistory",
  props: [
    "showEditInfo",
    "setshowEditInfo",
    "reload",
    "close",
    "info",
    "closeForm",
  ],
  components: { Loader },
  data() {
    return {
      loading: false,
      edit_error: null,
      edit_success: null,
    };
  },
  watch: {
    showEditInfo: {
      handler(newVal) {
        if (newVal) {
          this.info.InstitutionName = decryptData(
            this.info.InstitutionName,
            this.$decryptionKey
          );
          this.info.CourseName = decryptData(
            this.info.CourseName,
            this.$decryptionKey
          );

          // Convert date formats
          this.info.StartDate = this.convertDateToYYYYMMDD(this.info.StartDate);
          this.info.EndDate = this.convertDateToYYYYMMDD(this.info.EndDate);

          this.info.Awarded = decryptData(
            this.info.Awarded,
            this.$decryptionKey
          );
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getTabTitle"]),
  },
  methods: {
    convertDateToYYYYMMDD(dateTime) {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    updateEducationHistory() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/education/history/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.reload();
              this.$emit("closeOnSuccess", response.data.StatusMessage);
              this.closeForm();

              setTimeout(() => {
                this.setshowEditInfo();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>
